export default {
  vdoSetUnit: {
    id: '',
    vdoSet: null,
    courseOutline: null,
    courseOutlineUnit: null,
    teacher: null,
    unitSeq: null,
    code: '',
    totalVdoLength: null,
    status: '',
    remark: '',
    vdoSetTopics: [],
  },
  vdoSetUnits: [],
  processing: false,
  error: null,
  success: null,
}



